import '../App.css';
import HeroSection from '../sections/Hero';
import Header from '../components/Header';
import AboutSection from '../sections/About';
import TeamSection from '../sections/Team';
import ServicesSection from '../sections/Services';
import ContactSection from '../sections/Contact';

function HomePage() {
  return (
    <div className="App">
        <Header/>
        <HeroSection/>
        <AboutSection/>
        <TeamSection/>
        <ServicesSection/>
        <ContactSection/>
    </div>
  );
}

export default HomePage;
